import { Observable, Subject } from 'rxjs';

export class DynamicDialogRef {
  close(result?: any) {
    this._onClose.next(result);
  }

  destroy() {
    this._onDestroy.next(null);
  }

  private readonly _onClose = new Subject<any>();
  private readonly _onDestroy = new Subject<any>();

  onClose: Observable<any> = this._onClose.asObservable();
  onDestroy: Observable<any> = this._onDestroy.asObservable();
}
